module.exports = __webpack_public_path__ + "static/media/logo-transparency-square.7cd57e95.png";